import Vue from 'vue';
import { component, getter, prop } from '../../../decorators';

import VideoCard from '../../../components/video-card/video-card.vue';

@component({
   components: { VideoCard },
   watch: {
      getLoadedClips() {
         this.hasActiveOptions = false;
      }
   }
})
export default class GridClips extends Vue {
   @prop({ type: [String, Number] }) selected
   hasActiveOptions = false
   @getter() getLoadedClips

   details(clip) {
      this.$emit('details', clip);
   }
}
